
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, AlertTriangle } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";

const PodErrorState = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f9f8f5]">
      <Header />
      
      <main className="pt-20">
        <div className="max-w-[800px] mx-auto px-4 desktop:px-24 laptop:px-20 tablet:px-12 mobile:px-6 py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-2 text-[#374151] hover:text-[#374151]/80 mb-6 transition-colors"
            >
              <ArrowLeft size={16} />
              Back to Home
            </button>

            <div className="bg-red-50 border border-red-200 rounded-lg shadow-lg p-8">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="text-center"
              >
                <div className="flex justify-center mb-4">
                  <AlertTriangle className="text-red-600" size={48} />
                </div>
                <h1 className="text-2xl desktop:text-3xl laptop:text-2xl tablet:text-xl mobile:text-lg font-bold text-red-800 mb-2">
                  Error: Failed to Load Pod
                </h1>
                <p className="text-red-700 text-lg">
                  Please Contact Support
                </p>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PodErrorState;
